import { buildOnline } from '@/utils/global'
import _ from 'lodash'

import device_img from './NJANDKJ/device.png'

// 南京艾诺德科技发展有限公司
export const NJANDKJ = {
    CompanyId: 188,
    DeviceImg: device_img
}

export function isNJANDKJ(store) {   
    
    if (!buildOnline) {
        return false
    } 
    return _.get(store, 'getters.currentParentCompany') === NJANDKJ.CompanyId
}
